import React from "react";

export class ErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { error: null }; }
  static getDerivedStateFromError(error) { return { error }; }
  componentDidCatch(error, info) { console.error("UI crash:", error, info); }
  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div data-testid="error-boundary" className="max-w-xl mx-auto my-16 rounded-lg border border-red-200 bg-red-50 p-6 text-sm">
        <div className="font-semibold text-red-700">Kuch galat ho gaya — page load nahi hua.</div>
        <div className="mt-2 text-xs text-slate-700 break-words">{String(this.state.error?.message || this.state.error)}</div>
        <button className="mt-4 px-4 py-2 rounded-md bg-teal-700 text-white" onClick={() => window.location.reload()} data-testid="error-reload-btn">Page reload karein</button>
      </div>
    );
  }
}
